import productService from "../../services/api/ProductService";

const namespace = "product";

export const GET_ALL_PRODUCTS_SUCCESS = `${namespace}/GET_ALL_PRODUCTS_SUCCESS`;
export const GET_ALL_PRODUCTS_FAIL = `${namespace}/GET_ALL_PRODUCTS_FAIL`;

export function getProducts() {
    return (dispatch) => {
        return productService.getProducts()
            .then((result) => dispatch({ type: GET_ALL_PRODUCTS_SUCCESS, products: result}))
            .catch(err => dispatch({ type: GET_ALL_PRODUCTS_FAIL, err: JSON.stringify(err.stack)}));
    };
}
